import { Vault } from '@/features/vaults/types';

export const bscStakedSolvVaultId = 'bsc-staked-solv';

export const bscStakedSolvVault: Vault = {
  id: bscStakedSolvVaultId,
  type: 'multi-vault',
  name: 'Staked SOLV',
  description:
    'stSolv represents SOLV staked to support a Symbiotic-powered guarantee layer that secures Chainlink CCIP for cross-chain SolvBTC transfers. stSOLV rewards accrue with extra incentives via $SOLV and partner points programs. Unstaking requires a 21-day exit period.',
  category: 'restaking',
  address: '0x01C56d641c7dCE4F43679a807DD3b69872Ce8e3C',
  compatibility: 'ERC4626',
  interop: {
    type: 'layer-zero',
    sourceCore: '0x01C56d641c7dCE4F43679a807DD3b69872Ce8e3C',
    targetCore: '0x8545a1BaaDDdff45fBc316D80851214739189471',
    targetNetwork: 'ethereum',
    targetAddress: '0xdFFee0Fcbf7F900483E4E01FcD5C678c6E932023',
    sourceWithdrawalQueue: '0x19f602ee5F561C0209F9EC95cFA34E924C796dd8',
  },
  curators: ['solv-finance'],
  operator: [],
  points: [
    { entity: 'mellow', startTimestamp: 1738573595 },
    { entity: 'symbiotic', startTimestamp: 1738573595 },
  ],
  layer: 'Symbiotic',
  network: 'bsc',
  depositTokens: [
    {
      address: '0xabE8E5CabE24Cb36df9540088fD7cE1175b9bc52',
      decimals: 18,
      symbol: 'SOLV',
    },
  ],
  baseToken: '0xabE8E5CabE24Cb36df9540088fD7cE1175b9bc52',
  lpTokenSymbol: 'stSOLV',
  lpTokenDecimals: 18,
  withdrawDuration: 1900800,
  withdrawDurationDisplay: '22 days',
  staking: {
    network: 'bsc',
    contractType: 'synthetix-staking-rewards',
    contractAddress: '0x59890cDA7F434657F95341ADF7F861138a043DB5',
    rewardToken: {
      address: '0xda074C933122d03E83Fbad0d546494f83470154c',
      decimals: 18,
      symbol: 'vSOLV',
    },
  },
  allocations: {
    showAllocationsTab: true,
  },
  archived: true,
};
